import { IconTile } from "./IconTile";

type Props = {
  icon: React.ReactNode;
  title: string;
  description: string;
  /** "light" for cards on the cream page; "dark" for cards on the ink band. */
  surface?: "light" | "dark";
  iconTone?: "accent" | "viola" | "poolblue";
};

/** Icon + title + description card. Used on the home "How it works" band and About. */
export const FeatureCard = ({
  icon,
  title,
  description,
  surface = "light",
  iconTone = "accent",
}: Props) => {
  const isDark = surface === "dark";
  return (
    <div
      className={`rounded-xl p-6 ${
        isDark
          ? "border border-white/10 bg-white/[0.03]"
          : "border border-border-shell/60 dark:border-transparent bg-surface-blank shadow-simple"
      }`}
    >
      <IconTile tone={isDark ? "ink" : iconTone}>{icon}</IconTile>
      <h3
        className={`mt-4 font-heading text-lg font-bold ${
          isDark ? "text-white" : "text-text-full"
        }`}
      >
        {title}
      </h3>
      <p
        className={`mt-2 text-sm leading-relaxed ${
          isDark ? "text-white/60" : "text-text-light"
        }`}
      >
        {description}
      </p>
    </div>
  );
};
